import { apiCaller } from "./ApiCaller";

const LoginMe = async ({
  email,
  password,
  keepSignedIn,
}: {
  email: string;
  password: string;
  /**
   * GZ#3082 — the "Keep me signed in" tick. Until this shipped the checkbox was
   * dead React state: never sent, never read, so every session was 7 days
   * whether it was ticked or not. The backend must already accept
   * `keep_signed_in` (its login schema rejects unknown keys) — deploy backend
   * first.
   */
  keepSignedIn?: boolean;
}) => {
  try {
    const response = await apiCaller.post("/users/login", {
      email: email,
      password: password,
      keep_signed_in: Boolean(keepSignedIn),
    });
    return response.data;
  } catch (error:any) {
   throw error
  }
};

const ForgotPassword = async ({ email }: { email: string }) => {
  const response = await apiCaller.post("/users/forgot-password", { email });
  return response.data;
};

const ResetPassword = async ({ email, code, newPassword }: { email: string; code: string; newPassword: string }) => {
  const response = await apiCaller.post("/users/reset-password", { email, code, newPassword });
  return response.data;
};

export { LoginMe, ForgotPassword, ResetPassword };

// GZ#4917 — one-time link from the email (admin.bookandgo.app/reset-password?token=…).
// Public calls: the visitor has no session.
export type ResetLinkInfo = { email: string; full_name?: string; purpose: "reset" | "invite" };

const VerifyResetLink = async ({ token }: { token: string }): Promise<ResetLinkInfo> => {
  const response = await apiCaller.post("/users/reset-link/verify", { token });
  return response.data?.data;
};

const CompleteResetLink = async ({ token, newPassword }: { token: string; newPassword: string }) => {
  const response = await apiCaller.post("/users/reset-link/complete", { token, newPassword });
  return response.data;
};

export { VerifyResetLink, CompleteResetLink };
